module.exports = __webpack_public_path__ + "static/media/expo2020.f2ad1b95.png";